function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { T } from 'shared/helper/translate';
import Files, { endpoints } from 'shared/helper/file';
import { FILE_STATUS } from 'shared/helper/file/constants';
import { Controls } from 'shared/helper/form';
import UploadImage from '../../images/upload.svg';
import RubriqPlagiarismStatus from './RubriqPlagiarismStatus';
var Form = Controls.Form;
var fileType = 'ithenticate';
var defaultValues = {
  plagiarismFiles: []
};
var RubriqPlagiarismNoEditsMessage = function RubriqPlagiarismNoEditsMessage(_ref) {
  var onFileUploaded = _ref.onFileUploaded;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dragActive = _useState2[0],
    setDragActive = _useState2[1];
  var hasOpenedModal = useRef(false);
  var filePickerRef = useRef(null);
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _methods$watch = methods.watch(['plagiarismFiles']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    plagiarismFiles = _methods$watch2[0];
  var hasFile = plagiarismFiles && plagiarismFiles.length > 0;
  var handleFileSelect = function handleFileSelect() {
    if (filePickerRef.current) {
      filePickerRef.current();
    }
  };
  React.useEffect(function () {
    if (!hasFile) {
      return;
    }
    var isUploading = plagiarismFiles.some(function (file) {
      return file.status === FILE_STATUS.STATUS_UPLOAD_PROCESSING;
    });
    var isComplete = plagiarismFiles.some(function (file) {
      return file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS;
    });
    var hasError = plagiarismFiles.some(function (file) {
      return file.status === FILE_STATUS.STATUS_UPLOAD_FAILURE || file.status === 'filetype-failure' || file.error;
    });
    if (isUploading || isComplete || hasError) {
      if (!hasOpenedModal.current) {
        hasOpenedModal.current = true;
      }
      onFileUploaded(plagiarismFiles);
    }
  }, [plagiarismFiles, hasFile, onFileUploaded]);
  var handleSubmit = function handleSubmit() {};
  return /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "plagiarism-no-edits-custom-upload ".concat(dragActive ? 'hovered' : '')
  }, /*#__PURE__*/React.createElement(Files, {
    apiRoot: endpoints.researcher,
    maxUploads: 1,
    methods: methods,
    name: "plagiarismFiles",
    type: fileType,
    disabled: false,
    fileRenderer: function fileRenderer() {
      return null;
    },
    required: true,
    fileUploadButton: function fileUploadButton(_ref2) {
      var onClick = _ref2.onClick,
        isDragActive = _ref2.isDragActive,
        disabled = _ref2.disabled;
      filePickerRef.current = onClick;
      setDragActive(isDragActive);
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-column align-items-center gap-4 pt-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-column align-items-center text-center w-100 plagiarism-upload-content"
      }, /*#__PURE__*/React.createElement("img", {
        src: UploadImage,
        alt: "",
        className: "img-fluid"
      }), /*#__PURE__*/React.createElement("span", {
        className: "fw-semibold fs-4 mt-3"
      }, /*#__PURE__*/React.createElement(T, {
        source: "drag_and_drop_files"
      })), /*#__PURE__*/React.createElement("span", {
        className: "mt-2"
      }, /*#__PURE__*/React.createElement(T, {
        source: "click_to_browse"
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary mt-4 rounded-2",
        onClick: handleFileSelect,
        disabled: disabled
      }, /*#__PURE__*/React.createElement(T, {
        source: "choose_files"
      }))), /*#__PURE__*/React.createElement(RubriqPlagiarismStatus, {
        isNoEditsMessage: true
      }));
    }
  })));
};
export default RubriqPlagiarismNoEditsMessage;